import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { INVENTORY_TYPES_LOWERCASE } from 'client/constants/inventory-types';

const YEARS = { 2021: true, 2020: true, 2019: true };
export const CPO_CARS = {
  hyundai: { elantra: YEARS, sonata: YEARS, tucson: YEARS, palisade: YEARS, 'santa-fe': YEARS },
};

export function isCpoMessageMake(make) {
  return ['mercedes-benz', 'hyundai'].includes(makeNiceName(make));
}

export function getCpoMakeName(facets) {
  return (facets?.make?.length === 1 && facets.make[0]) || null;
}

export function checkCpoMessage(facets) {
  const make = getCpoMakeName(facets);
  const type = facets?.inventoryType ?? [];
  const isCpoEligible = type.length === 1 && type.includes(INVENTORY_TYPES_LOWERCASE.CPO);
  return isCpoEligible && isCpoMessageMake(make);
}
